import $ from 'domtastic';
import axios from 'axios';

class Spritesheet {
  constructor() {
    this.cacheDom();
    this.load();
  }

  cacheDom() {
    this.$spriteContainer = $('.js-spritesheet');
  }

  load() {
    axios('/app/themes/herok/dist/icons/sprite.svg')
      .then((response) => {
        this.$spriteContainer.html(response.data);
      })
      .catch((error) => {
        console.log('Could not load spritesheet: ', error);
      });
  }
}

export default new Spritesheet();



// WEBPACK FOOTER //
// ./components/Spritesheet.js